// All values below are FICTIONAL DEMO DATA for illustration only.
export const DEMO_NOTICE = "Demo data — illustrative only.";

export const overviewStats = {
  totalBalance: 12480.0,
  activeAgents: 8,
  monthlySpend: 2184.2,
  pendingApprovals: 3,
};

export const spendChart = [
  { day: "Mon", spend: 210 },
  { day: "Tue", spend: 340 },
  { day: "Wed", spend: 180 },
  { day: "Thu", spend: 420 },
  { day: "Fri", spend: 290 },
  { day: "Sat", spend: 460 },
  { day: "Sun", spend: 284 },
];

export const agentActivity = [
  { name: "Research Agent", spent: 127.4 },
  { name: "Operations Agent", spent: 482.2 },
  { name: "Customer Support Agent", spent: 74.8 },
  { name: "Procurement Agent", spent: 1120.4 },
];

export const agents = [
  {
    id: "research-agent",
    name: "Research Agent",
    status: "Active",
    risk: "Low",
    permission: "Controlled",
    walletBalance: 1240.0,
    monthlyBudget: 500,
    spent: 127.4,
    dailyLimit: 100,
    transactionLimit: 100,
    permissions: {
      Software: "Allowed",
      "API Services": "Allowed",
      "New Merchants": "Approval Required",
      "Transactions above $100": "Approval Required",
    },
  },
  {
    id: "operations-agent",
    name: "Operations Agent",
    status: "Active",
    risk: "Low",
    permission: "Controlled",
    walletBalance: 2100.0,
    monthlyBudget: 1500,
    spent: 482.2,
    dailyLimit: 300,
    transactionLimit: 250,
    permissions: {
      Software: "Allowed",
      "API Services": "Allowed",
      "New Merchants": "Approval Required",
      "Transactions above $250": "Approval Required",
    },
  },
  {
    id: "customer-support-agent",
    name: "Customer Support Agent",
    status: "Active",
    risk: "Low",
    permission: "Controlled",
    walletBalance: 640.0,
    monthlyBudget: 400,
    spent: 74.8,
    dailyLimit: 80,
    transactionLimit: 60,
    permissions: {
      Software: "Allowed",
      "API Services": "Allowed",
      "New Merchants": "Blocked",
      "Transactions above $60": "Approval Required",
    },
  },
  {
    id: "procurement-agent",
    name: "Procurement Agent",
    status: "Active",
    risk: "Medium",
    permission: "Controlled",
    walletBalance: 3200.0,
    monthlyBudget: 2000,
    spent: 1120.4,
    dailyLimit: 800,
    transactionLimit: 500,
    permissions: {
      Software: "Allowed",
      "API Services": "Allowed",
      "New Merchants": "Approval Required",
      "Transactions above $500": "Approval Required",
    },
  },
  {
    id: "devops-agent",
    name: "DevOps Cloud Agent",
    status: "Active",
    risk: "Low",
    permission: "Controlled",
    walletBalance: 1800.0,
    monthlyBudget: 1200,
    spent: 640.0,
    dailyLimit: 400,
    transactionLimit: 300,
    permissions: {
      Software: "Allowed",
      "API Services": "Allowed",
      "New Merchants": "Approval Required",
      "Transactions above $300": "Approval Required",
    },
  },
  {
    id: "ad-optimizer-agent",
    name: "Ad Optimizer Agent",
    status: "Paused",
    risk: "Medium",
    permission: "Controlled",
    walletBalance: 950.0,
    monthlyBudget: 900,
    spent: 318.0,
    dailyLimit: 200,
    transactionLimit: 150,
    permissions: {
      Software: "Blocked",
      "API Services": "Allowed",
      "New Merchants": "Approval Required",
      "Transactions above $150": "Approval Required",
    },
  },
];

export const wallets = [
  { id: "w-research", agent: "Research Agent", balance: 1240.0, currency: "USD", card: "•• 4821", status: "Active" },
  { id: "w-ops", agent: "Operations Agent", balance: 2100.0, currency: "USD", card: "•• 1190", status: "Active" },
  { id: "w-support", agent: "Customer Support Agent", balance: 640.0, currency: "USD", card: "•• 7730", status: "Active" },
  { id: "w-proc", agent: "Procurement Agent", balance: 3200.0, currency: "USD", card: "•• 2045", status: "Active" },
  { id: "w-devops", agent: "DevOps Cloud Agent", balance: 1800.0, currency: "USD", card: "•• 9981", status: "Active" },
  { id: "w-ad", agent: "Ad Optimizer Agent", balance: 950.0, currency: "USD", card: "•• 3360", status: "Frozen" },
];

export const transactions = [
  { id: "txn-1001", date: "2026-06-12 09:14", agent: "Research Agent", merchant: "OpenAI API", amount: 24.0, category: "API Services", status: "Approved", risk: "Low", approval: "Auto" },
  { id: "txn-1002", date: "2026-06-12 10:02", agent: "Operations Agent", merchant: "AWS", amount: 82.5, category: "Infrastructure", status: "Approved", risk: "Low", approval: "Auto" },
  { id: "txn-1003", date: "2026-06-12 11:48", agent: "Procurement Agent", merchant: "Example Software Vendor", amount: 640.0, category: "Software", status: "Pending Approval", risk: "Medium", approval: "Required" },
  { id: "txn-1004", date: "2026-06-11 16:21", agent: "Customer Support Agent", merchant: "Zendesk", amount: 49.0, category: "Software", status: "Approved", risk: "Low", approval: "Auto" },
  { id: "txn-1005", date: "2026-06-11 14:05", agent: "DevOps Cloud Agent", merchant: "Google Cloud", amount: 210.3, category: "Infrastructure", status: "Approved", risk: "Low", approval: "Auto" },
  { id: "txn-1006", date: "2026-06-11 08:30", agent: "Procurement Agent", merchant: "New Vendor Inc.", amount: 850.0, category: "Software", status: "Pending Approval", risk: "High", approval: "Required" },
  { id: "txn-1007", date: "2026-06-10 19:44", agent: "Research Agent", merchant: "Anthropic API", amount: 18.75, category: "API Services", status: "Approved", risk: "Low", approval: "Auto" },
  { id: "txn-1008", date: "2026-06-10 12:12", agent: "Operations Agent", merchant: "Notion", amount: 16.0, category: "Software", status: "Approved", risk: "Low", approval: "Auto" },
  { id: "txn-1009", date: "2026-06-09 15:55", agent: "Ad Optimizer Agent", merchant: "Meta Ads", amount: 300.0, category: "Advertising", status: "Rejected", risk: "Medium", approval: "Denied" },
];

export const approvals = [
  {
    id: "apr-1",
    agent: "Procurement Agent",
    merchant: "New Vendor Inc.",
    amount: 850.0,
    reason: "Transaction exceeds the agent's $500 approval threshold.",
    policy: "Approval required above $500",
    time: "2 min ago",
    risk: "High",
    priority: "High",
    tag: "New",
  },
  {
    id: "apr-2",
    agent: "Procurement Agent",
    merchant: "Example Software Vendor",
    amount: 640.0,
    reason: "Transaction exceeds the agent's $500 approval threshold.",
    policy: "Approval required above $500",
    time: "18 min ago",
    risk: "Medium",
    priority: "High",
    tag: "New",
  },
  {
    id: "apr-3",
    agent: "DevOps Cloud Agent",
    merchant: "Datadog",
    amount: 320.0,
    reason: "New merchant requires human approval before first payment.",
    policy: "New merchants require approval",
    time: "1 hr ago",
    risk: "Low",
    priority: "Normal",
    tag: "Expiring",
  },
];

export const policies = [
  { id: "p-1", name: "Per-transaction cap", scope: "All agents", value: "$500", type: "Limit", enabled: true },
  { id: "p-2", name: "Daily spend cap", scope: "All agents", value: "$800", type: "Limit", enabled: true },
  { id: "p-3", name: "Approved merchants", scope: "Procurement Agent", value: "AWS, GCP, OpenAI", type: "Whitelist", enabled: true },
  { id: "p-4", name: "Restricted categories", scope: "All agents", value: "Gambling, Crypto", type: "Blocklist", enabled: true },
  { id: "p-5", name: "New merchant approval", scope: "All agents", value: "Required", type: "Approval", enabled: true },
  { id: "p-6", name: "Monthly budget", scope: "Research Agent", value: "$500", type: "Budget", enabled: true },
];

export const analyticsCategory = [
  { name: "Infrastructure", value: 920 },
  { name: "API Services", value: 540 },
  { name: "Software", value: 480 },
  { name: "Advertising", value: 244 },
];

export const analyticsTrend = [
  { month: "Jan", spend: 1420 },
  { month: "Feb", spend: 1680 },
  { month: "Mar", spend: 1510 },
  { month: "Apr", spend: 1920 },
  { month: "May", spend: 2040 },
  { month: "Jun", spend: 2184 },
];

export const features = [
  {
    icon: "SlidersHorizontal",
    title: "Programmable Spending Limits",
    desc: "Set exactly how much each AI agent can spend.",
    points: ["Per transaction", "Daily", "Weekly", "Monthly", "Merchant", "Category"],
  },
  {
    icon: "CheckCheck",
    title: "Approval Workflows",
    desc: "Require human approval when a transaction exceeds a threshold or falls outside policy.",
    points: ["Threshold-based", "Policy-based", "One-click approve / reject", "Audit trail"],
  },
  {
    icon: "Wallet",
    title: "Agent-Level Wallets",
    desc: "Give every AI agent its own controlled financial environment.",
    points: ["Wallet", "Budget", "Permissions", "Spending history", "Rules", "Status"],
  },
  {
    icon: "Activity",
    title: "Real-Time Monitoring",
    desc: "Track every movement across your agent fleet as it happens.",
    points: ["Transactions", "Amount", "Merchant", "Agent", "Timestamp", "Status & Risk"],
  },
  {
    icon: "ShieldCheck",
    title: "Permission Controls",
    desc: "Founders decide exactly what each agent is allowed to do.",
    points: ["Approve software purchases", "Block restricted categories", "Allow approved merchants", "Require approval for new merchants", "Limit transaction size"],
  },
  {
    icon: "Power",
    title: "Emergency Controls",
    desc: "Instantly intervene when something looks wrong.",
    points: ["Pause Agent", "Freeze Wallet", "Revoke Permissions", "Disable Payments"],
  },
];

export const howItWorks = [
  { step: "01", title: "CREATE", desc: "Create a Vvvoraa wallet and connect your AI agent." },
  { step: "02", title: "CONTROL", desc: "Define spending limits, permissions, merchant rules, budgets and approval requirements." },
  { step: "03", title: "LET IT ACT", desc: "Your agent executes approved transactions while Vvvoraa continuously enforces the financial rules." },
];

export const securityPrinciples = [
  { icon: "KeyRound", title: "Least-Privilege Access", desc: "Give each agent only the permissions it needs." },
  { icon: "SlidersHorizontal", title: "Transaction Controls", desc: "Set limits and policies before an agent can spend." },
  { icon: "UserCheck", title: "Human Approval", desc: "Keep humans in the loop for sensitive transactions." },
  { icon: "Activity", title: "Continuous Monitoring", desc: "Track financial activity across every agent." },
  { icon: "Ban", title: "Instant Revocation", desc: "Pause agents and revoke payment permissions immediately." },
  { icon: "ScrollText", title: "Transparent History", desc: "Maintain a clear record of transactions and policy decisions." },
];
